import { uuid } from '../utilidades/uuid.js';
import { inicializarInternacionalizacao } from '../localizacao/eventoBuscarVagaRedirect/eventoBuscarVagaRedirect.js'
import i18next from 'i18next';
import { isNullOrEmpty } from './isNullOrEmpty.js';
import { getFetch } from './getFetch.js';

const chaveLocalStorageBuscasRecentesCargo = 'vagasBuscasRecentesCargo';
const chaveLocalStorageBuscasRecentesLocalizacao = 'vagasBuscasRecentesLocalizacao';
const chaveLocalStorageCidadesSugestoes = 'sugestoesCidade';
inicializarInternacionalizacao();

console.log('eventoBuscarVagaRedirect');

const sugestoesCidadesPadrao = [
    { nome: i18next.t('SugestoesCidadesPadraoRemoto') },
    { nome: 'Brasília, DF' },
    { nome: 'São Paulo, SP' },
    { nome: 'São José do Rio Preto, SP' },
    { nome: 'Cuiabá, MT' },
    { nome: 'Maringá, PR' },
    { nome: 'Natal, RN' },
    { nome: 'Belo Horizonte, MG' },
    { nome: 'Taguatinga - Brasília, DF' },
    { nome: 'Rio de Janeiro, RJ' },
    { nome: 'Ribeirão Preto, SP' }
];


export async function obterSugestoesCidades(cb = null) {
    let cacheSugestoesCidades = [];
    if (sessionStorage.getItem(chaveLocalStorageCidadesSugestoes)) {
        cacheSugestoesCidades = JSON.parse(sessionStorage.getItem(chaveLocalStorageCidadesSugestoes));
    }

    const { getGeoData } = await import('../utilidades/geoData');
    let retorno = cacheSugestoesCidades;
    const geoData = getGeoData();

    try {
        if (cacheSugestoesCidades.length == 0) {
            const baseURLAPI = URL_API + 'vagas/buscar-novo';
            const hotSiteEmpresaID = document.getElementById("hotSiteEmpresaID");
            const hotSiteUrl = document.getElementById('hotSiteUrl');

            const parametrosURL = new URLSearchParams();
            parametrosURL.append('pagina', 1);
            parametrosURL.append('itensPagina', 1);
            parametrosURL.append('ordenacao', 'Relevancia');
         
            if (hotSiteEmpresaID != undefined && hotSiteUrl != undefined) {
                parametrosURL.append('empresa', hotSiteEmpresaID.value);
                parametrosURL.append('hotSiteUrl', hotSiteUrl.value);
            }

            const request = await fetch(`${baseURLAPI}?${parametrosURL.toString()}`);

            const response = await request.json();

            if (response.sucesso) {
                if (!response.model.facets || !response.model.facets.cidade) {
                    retorno = sugestoesCidadesPadrao;
                } else {
                    const topCidades = response.model.facets.cidade.splice(0, 10);

                    const possuiRemoto = response.model.facets.remoto?.filter(x => x.nome.includes('Remoto'))?.length > 0;
                    if (possuiRemoto) {
                        retorno.push({ nome: i18next.t('SugestoesCidadesPadraoRemoto') });
                    }

                    for (const cidadeObject of topCidades) {
                        if (retorno.find(x => x.nome.includes(cidadeObject.nome)) || cidadeObject.nome.includes('Brasil') || cidadeObject.nome.includes('Remoto')) {
                            continue;
                        }

                        retorno.push(cidadeObject);
                    }
                }

                sessionStorage.setItem(chaveLocalStorageCidadesSugestoes, JSON.stringify(retorno));
            } else {
                retorno = sugestoesCidadesPadrao;
            }
        }
    }
    catch {
        //Caso dê algum erro com o request, coloca as sugestões padrões
        retorno = sugestoesCidadesPadrao;
    }

    if (geoData.existe) {
        //Filtra a lista para não ter a mesma cidade repetida para add no topo
        retorno = retorno.filter(x => !x.nome.includes(geoData.cidadeCompleta));
        retorno.unshift({ nome: geoData.cidadeCompleta });
    }

    //Callback para indicar apenas que finalizou toda operação de request
    if (cb != null) { cb(); }

    return retorno;
}

export function adicionarSugestaoCidade(nome, adicionarNoTopoLista = false){
    if(nome == null || nome.trim().length == 0){
        return;
    }
    
    let arrayDados = [];
    const dadoParaInserir = { nome };    
    const dadosSalvos = obterSugestoesCidades();

    if(dadosSalvos != null && dadosSalvos.length > 0)
    {
        //Se houver um dado igual não adiciona
        if(dadosSalvos.filter(dado => dado.nome.includes(dadoParaInserir.nome)).length > 0){
            return;
        }
        arrayDados = dadosSalvos;
    }

    if(adicionarNoTopoLista){
        arrayDados.unshift(dadoParaInserir);
    }else {
        arrayDados.push(dadoParaInserir);
    }
    localStorage.setItem(chaveLocalStorageCidadesSugestoes, JSON.stringify(arrayDados));
}

export function removerSugestaoCidade(nome){
    const dadosSalvos = obterSugestoesCidades();

    if(dadosSalvos == null || dadosSalvos.length == 0)
    {
        return;
    }
    const dadosSalvosNovo = dadosSalvos.filter(x => x.nome != nome);
    localStorage.setItem(chaveLocalStorageCidadesSugestoes, JSON.stringify(dadosSalvosNovo));
}

const templatesVagaBuscasRecentes = {
    headerListagem(container){
        const info = document.createElement('div');
        info.setAttribute("class", "d-flex justify-content-between px-4 pt-3 pb-2");
        info.innerHTML = `
            <span class="text-muted" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                <small>${i18next.t('TemplateVagaBuscasRecentes')}</small>
            </span>
        `;
        container.prepend(info);
    },
    async itemCargoListagem(elemento, data){        
        elemento.setAttribute('class', `busca_${data.value.id}`);
        elemento.style = "display: flex; justify-content: space-between;";
        elemento.innerHTML = `
                    <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                        <small>${data.match}</small>
                    </span>
                    <span style="margin-right: -15px; display: flex; align-items: center; font-size: 13px; font-weight: 100; text-transform: uppercase; color: rgba(0,0,0,.2);">
                        <button data-id="${data.value.id}" type="button" class="fechar-modal btn-remove-busca-recente"><i class="bi bi-x-circle"></i></button>
                    </span>`
                ;
        elemento.querySelectorAll('.btn-remove-busca-recente').forEach(el => el.addEventListener('click', () => {
            //Remove do localStorage baseado na busca id
            const buscaId = el.dataset.id;
            vagasBuscasRecentesCargoRemover(buscaId);
            document.querySelector(`.busca_${buscaId}`).remove();
        }));

    },
    async itemLocalizacaoListagem(elemento, data){
        let htmlElemento = '';

        elemento.style = "display: flex; justify-content: space-between;";
        elemento.innerHTML = `
            <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                <small>${data.match}</small>
            </span>`;

        //Se for um elemento que seja de busca recente (para nao confundir com a listagem de cidades normal) adiciona botão de remover
        if(data.value.buscaRecente != undefined && data.value.buscaRecente){
            elemento.setAttribute('class', `busca_${data.value.id}`);
            elemento.innerHTML += `            
                <span style="margin-right: -15px; display: flex; align-items: center; font-size: 13px; font-weight: 100; text-transform: uppercase; color: rgba(0,0,0,.2);">
                    <button data-id="${data.value.id}" type="button" class="fechar-modal btn-remove-busca-recente-localizacao"><i class="bi bi-x-circle"></i></button>
                </span>
            `;
            elemento.querySelectorAll('.btn-remove-busca-recente-localizacao').forEach(el => el.addEventListener('click', () => {
                //Remove do localStorage baseado na busca id
                const buscaId = el.dataset.id;
                vagasBuscasRecentesLocalizacaoRemover(buscaId);
                document.querySelector(`.busca_${buscaId}`).remove();
            }));
        }
    }
};

export async function autocompleteBuscaRecenteLocalizacao(formHeaderBuscarVagas, seletorInput = '#localizacao', sugestoes = []) {

    const { default: autoComplete } = await import('@tarekraafat/autocomplete.js');

    let sugestoesCidades = [];
    let buscasRecentesLocalizacao = vagasBuscasRecentesLocalizacaoObter();

    let exibirSugestoesCidades = true;
    let exibindoCidadesAPI = false;

    const autoCompleteLocalizacao = new autoComplete({
        diacritics: true, //entender sinais agudos e etc
        submit: true,
        selector: seletorInput,
        placeHolder: i18next.t('AutocompletePlaceholder'),
        threshold: 0,
        debounce: 500,
        data: {
            src: async (query) => {
                try {
                    let retorno = [];
                    let querySemAcentos = query.toLowerCase();
                    querySemAcentos = querySemAcentos.normalize("NFD").replace(/\p{Diacritic}/gu, "");

                    function _dadosDoLocalStorage(){

                        exibindoCidadesAPI = false;

                        buscasRecentesLocalizacao = vagasBuscasRecentesLocalizacaoObter().filter(item => {
                            let nomeSemAcentos = item.nome.toLowerCase();
                            nomeSemAcentos = nomeSemAcentos.normalize("NFD").replace(/\p{Diacritic}/gu, "");
                            return nomeSemAcentos.includes(querySemAcentos);
                        });

                        retorno = buscasRecentesLocalizacao;
                        return (buscasRecentesLocalizacao != null && buscasRecentesLocalizacao.length > 0);
                    }

                    /*function _possuiEmSugestoesCidades(){
                        // console.log('analisando de sugestões de cidades');

                        const sugestoesCidadesFiltrada = sugestoesCidades.filter(item => {
                            let nomeSemAcentos = item.nome.toLowerCase();
                            nomeSemAcentos = nomeSemAcentos.normalize("NFD").replace(/\p{Diacritic}/gu, "");
                            return nomeSemAcentos.includes(querySemAcentos);
                        });

                        return (sugestoesCidadesFiltrada != null && sugestoesCidadesFiltrada.length > 0);
                    }*/

                    if(query.length >= 3){
                        //console.log('buscando da API');   
                        
                        exibindoCidadesAPI = true;
                        exibirSugestoesCidades = false;

                        const requestCidades = await fetch(`${URL_API}variaveis/cidades/buscarV2?query=${query}`);
                        const data = await requestCidades.json();
                        retorno = data.dados;

                        if(retorno == null || Object.keys(retorno).length == 0){
                            exibirSugestoesCidades = true;
                            _dadosDoLocalStorage();
                        }                        

                    }else{
                        exibirSugestoesCidades = true;
                        _dadosDoLocalStorage();
                    }

                    // console.log({retorno, query});

                    return retorno;
                } catch (error) {
                    console.log(error);
                }
            },
            keys: ["nome"]
        },
        resultsList: {
            noResults: true, //Caso não tenha itens, permite abrir a listagem contendo as sugestões de cidade
            maxResults: 20,
            element: (list, data) => {
                let temBuscasRecentes = false;
                list.setAttribute('class', 'listagem-localizacao');
                // console.log(list);

                //Exibe a header de buscas recentes somente quando o termo em questão está na lista
                if (buscasRecentesLocalizacao.length > 0 && !exibindoCidadesAPI) {
                    temBuscasRecentes = true;
                    templatesVagaBuscasRecentes.headerListagem(list);
                }

                //Cidades destaques
                if(exibirSugestoesCidades){

                    if(temBuscasRecentes){
                        const linhaSeparadora = document.createElement("hr");
                        linhaSeparadora.setAttribute("style", "margin: 5px 0 0 0;");
                        list.append(linhaSeparadora);
                    }

                    const headerSugestoes = document.createElement('div');
                    headerSugestoes.setAttribute("class", "d-flex justify-content-between px-4 pt-3 pb-2");
                    headerSugestoes.innerHTML = `
                        <span class="text-muted" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                            <small>${i18next.t('ResultsListSugestoes')}</small>
                        </span>
                    `;
                    list.append(headerSugestoes);
                    sugestoesCidades = sugestoesCidades.concat(sugestoes);
                    sugestoesCidades.reverse()

                    // remove cidades duplicadas
                    sugestoesCidades = sugestoesCidades.filter((seenIds => obj => !seenIds.has(obj.id) && seenIds.add(obj.id))(new Set())); 

                    for(let i = 0; i < sugestoesCidades.length; ++i){
                        const info = document.createElement('li');
                        info.setAttribute("style", "display: flex; justify-content: space-between;");
                        info.innerHTML = `
                            <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                                <small class="cidade-destaque-item">${sugestoesCidades[i].nome}</small>
                            </span>
                        `;
                        list.append(info);
                    }
                }
            }
        },
        resultItem: {
            element: (item, data) => {
                templatesVagaBuscasRecentes.itemLocalizacaoListagem(item, data);
            },
            highlight: true
        },
        events: {
            input: {                
                selection: (event) => {
                    //Se for um item que não seja preenchido em 'data'
                    if(event.detail.selection.value == undefined){
                        autoCompleteLocalizacao.input.value = event.target.nextSibling.querySelectorAll('.cidade-destaque-item')[event.detail.selection.index - buscasRecentesLocalizacao.length].textContent;
                    }
                    else {
                        const objetoSelecionado = event.detail.selection.value;
                        autoCompleteLocalizacao.input.value = objetoSelecionado.nome;
                    }                    
                },
                focus: async (event) => {
                    //Ao dar focus no input, inicia o autocomplete com uma pesquisa em branco carregando todas as suas buscas recentes
                    const inputLocalizacao = document.querySelector(seletorInput);
                    const valorAntesLoading = inputLocalizacao.value;
                    inputLocalizacao.value = i18next.t('SugestoesCidadesCarregando');

                    sugestoesCidades = await obterSugestoesCidades(() => {
                        inputLocalizacao.value = valorAntesLoading;
                        autoCompleteLocalizacao.start();
                    });
                }
            }
        }
    });

    if(formHeaderBuscarVagas != null){
        //Evento que ao pesquisar no form header vai redirecionar para a tela de vagas
        formHeaderBuscarVagas.addEventListener('submit', eventoBuscarVagaRedirect);
    }

    return autoCompleteLocalizacao;
}

export async function tomSelectBuscaLocalizacao(selector, multiple) {
    const module = await import('tom-select');
    const TomSelect = module.default;
    new TomSelect(selector, {
        plugins: ['clear_button'],
        valueField: 'nome',
        labelField: 'Localizacao',
        searchField: [],
        maxItems: 5,
        preload: true,
        load: async (query, callback) => {
            try {
                let retorno = [];
                let buscasRecentesLocalizacao = vagasBuscasRecentesLocalizacaoObter();
                function _dadosDoLocalStorage(){
                    const querySemAcentos = query.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
                    
                    buscasRecentesLocalizacao = vagasBuscasRecentesLocalizacaoObter().filter(item => {
                        let nomeSemAcentos = item.nome.toLowerCase();
                        nomeSemAcentos = nomeSemAcentos.normalize("NFD").replace(/\p{Diacritic}/gu, "");
                        return nomeSemAcentos.includes(querySemAcentos);
                    });

                    retorno = buscasRecentesLocalizacao;
                    return (buscasRecentesLocalizacao != null && buscasRecentesLocalizacao.length > 0);
                }

                if(query.length >= 3){
                    const requestCidades = await fetch(`${URL_API}variaveis/cidades/buscar/${query}`);
                    const data = await requestCidades.json();
                    retorno = data.dados;

                    if(retorno == null || Object.keys(retorno).length == 0){
                        _dadosDoLocalStorage();
                    }                        

                } else 
                    _dadosDoLocalStorage();

                callback(retorno);
            } catch (error) {
                console.log(error);
            }
        },
        onInitialize: function() {
            // Se já houver algum valor selecionado, remove o placeholder
            // Lembrando que para "multiple" esse valor será array.
            const currentValue = this.getValue();
            
            const hasValue = Array.isArray(currentValue)
                ? currentValue.length > 0
              : !!currentValue; // para single
            
            if (hasValue) {
                this.settings.placeholder = '';
                this.control_input.setAttribute('placeholder', '');
            }
        },
        onChange: function(value) {

            let hasValue = false;

            if (Array.isArray(value)) {
                hasValue = value.length > 0;
            } else {
                hasValue = !!value;
            }

            if (hasValue) {
                this.settings.placeholder = '';
                this.control_input.setAttribute('placeholder', '');
            } else {
                this.settings.placeholder = 'Procurar cidade...';
                this.control_input.setAttribute('placeholder', 'Procurar cidade...');
            }

            if (isNullOrEmpty(value) && (typeof avisoAssuntoSelecionado !== 'undefined' && avisoAssuntoSelecionado)) {
                avisoAssuntoSelecionado?.classList.add('d-none');
                todoFormulario?.classList.add('d-none');
                document.getElementById('row-assunto-subcategoria')?.classList.add('d-none');
                return;
            }
            getFetch(`/${CULTURE_EMPREGARE}/PaginasEstaticas/ObterAssuntoSubcategorias?assuntoCategoriaID=` + value,
                (resultado) => {

                    if(!resultado.dados)
                        return;

                    let opcoesSubcategorias = resultado.dados;


                    if (opcoesSubcategorias.length > 0  && (typeof selectAssuntoSubcategoria !== 'undefined' && selectAssuntoSubcategoria)) {

                        selectAssuntoSubcategoria.clear(); //atual seleção
                        selectAssuntoSubcategoria.clearOptions();
                        selectAssuntoSubcategoria.addOptions(opcoesSubcategorias);

                        if (opcoesSubcategorias.length == 1) {
                            document.getElementById('row-assunto-subcategoria').classList.add('d-none');
                            selectAssuntoSubcategoria.setValue(opcoesSubcategorias[0].ID);
                        } else {
                            document.getElementById('row-assunto-subcategoria').classList.remove('d-none');
                            todoFormulario.classList.add('d-none');
                            avisoAssuntoSelecionado.classList.add('d-none');
                        }
                    }

                },
                (erro) => {
                    console.log(erro);
                }
            );
        },
        onItemAdd: function(value, item) {

            function clearDynamicOptions(tomSelectInstance) {
                // Pega todas as chaves (valores) das opções carregadas.
                const allOptionKeys = Object.keys(tomSelectInstance.options);
              
                // Pega os itens selecionados. Pode vir como string (single) ou array (multiple).
                let selectedKeys = tomSelectInstance.getValue();
              
                // Garante que `selectedKeys` seja um array para comparar.
                if (!Array.isArray(selectedKeys)) {
                  selectedKeys = selectedKeys ? [selectedKeys] : [];
                }
              
                for (const key of allOptionKeys) {
                  const opt = tomSelectInstance.options[key];
                    
                  if (opt.ispermanent !== "true") {
                    // ...e NÃO está selecionado, removemos.
                    if (!selectedKeys.includes(key)) {
                      tomSelectInstance.removeOption(key);
                    }
                  }
                }
              }
            // Limpa o texto que sobrou
            this.setTextboxValue('');
            this.close();

            clearDynamicOptions(this);
        },
        render: {
            option: function (data, escape) {
                console.log(data)
                return `
                    <div class="">
                        <p class="mb-0">${escape(data.nome)}</p>
                    </div>
                `;
            },
            item: function (data, escape) {
                console.log(data)
                return '<div title="' + escape(data.nome) + '">' + escape(data.nome) + '</div>';
            }
        }
    });
}

export async function autocompleteBuscaRecenteCargo(form, seletorInput = 'input[name="cargo"]'){
    const { default: autoComplete } = await import('@tarekraafat/autocomplete.js');
    
    const autocompleteCargo = new autoComplete({
        diacritics: true,
        submit: true,
        selector: ()  => form.querySelector(seletorInput),
        threshold: 0,
        data: {
            src: async (query) => {
                try {
                    //console.log(query);
                    const dadosBuscasRecentes = vagasBuscasRecentesCargoObter();
                    const listaFiltradaBuscasRecentes = dadosBuscasRecentes.filter(x => x.cargo.includes(query));
                    return listaFiltradaBuscasRecentes;
                } catch (error) {
                    console.log(error);
                }
            },
            keys: ['cargo']
            // cache: true,
        },
        resultsList: {
            element: (list, data) => {
                if (vagasBuscasRecentesCargoObter().length > 0) {
                    templatesVagaBuscasRecentes.headerListagem(list);
                }
            }
        },
        resultItem: {
            element: (item, data) => {
                templatesVagaBuscasRecentes.itemCargoListagem(item, data);
            },
            highlight: true,
        },
        events: {
            input: {
                selection: (event) => {
                    const objetoSelecionado = event.detail.selection.value;
                    autocompleteCargo.input.value = objetoSelecionado.cargo;
                },
                focus: (event) => {
                    //Ao dar focus no input, inicia o autocomplete com uma pesquisa em branco carregando todas as suas buscas recentes
                    autocompleteCargo.start('');
                }
            }
        }
    });

}

function vagasBuscasRecentesCargoObter()
{
    const dadosSalvos = localStorage.getItem(chaveLocalStorageBuscasRecentesCargo);
    if(dadosSalvos == null || dadosSalvos == undefined){
        return [];
    }
    return JSON.parse(dadosSalvos) ?? [];
}

function vagasBuscasRecentesLocalizacaoObter()
{
    const dadosSalvos = localStorage.getItem(chaveLocalStorageBuscasRecentesLocalizacao);
    if(dadosSalvos == null || dadosSalvos == undefined){
        return [];
    }
    return JSON.parse(dadosSalvos) ?? [];
}

function vagasBuscasRecentesCargoRemover(id)
{    
    const dadosSalvos = vagasBuscasRecentesCargoObter();

    if(dadosSalvos == null || dadosSalvos.length == 0)
    {
        return;
    }

    const dadosSalvosNovo = dadosSalvos.filter(x => x.id != id);
    localStorage.setItem(chaveLocalStorageBuscasRecentesCargo, JSON.stringify(dadosSalvosNovo));    
}

function vagasBuscasRecentesLocalizacaoRemover(id)
{    
    const dadosSalvos = vagasBuscasRecentesLocalizacaoObter();

    if(dadosSalvos == null || dadosSalvos.length == 0)
    {
        return;
    }

    const dadosSalvosNovo = dadosSalvos.filter(x => x.id != id);
    localStorage.setItem(chaveLocalStorageBuscasRecentesLocalizacao, JSON.stringify(dadosSalvosNovo));    
}

export function vagasBuscasRecentesCargoAdicionar(cargo)
{
    if(cargo == null || cargo.trim().length == 0){
        return;
    }
    let arrayDados = [];
    const dadoParaInserir = { id: uuid(), cargo };    
    const dadosSalvos = vagasBuscasRecentesCargoObter();

    if(dadosSalvos != null && dadosSalvos.length > 0)
    {
        console.log(dadosSalvos.filter(dado => dado.cargo.includes(dadoParaInserir.cargo)));
        //Se houver um dado igual não adiciona
        if(dadosSalvos.filter(dado => dado.cargo.includes(dadoParaInserir.cargo)).length > 0){
            return;
        }
        arrayDados = dadosSalvos;
    }

    arrayDados.push(dadoParaInserir);
    localStorage.setItem(chaveLocalStorageBuscasRecentesCargo, JSON.stringify(arrayDados));
}

export function vagasBuscasRecentesLocalizacaoAdicionar(localizacao)
{
    if(localizacao == null || localizacao.trim().length == 0){
        return;
    }
    let arrayDados = [];
    const dadoParaInserir = { id: uuid(), nome: localizacao, buscaRecente: true };    
    const dadosSalvos = vagasBuscasRecentesLocalizacaoObter();

    if(dadosSalvos != null && dadosSalvos.length > 0)
    {
        //Se houver um dado igual não adiciona
        if(dadosSalvos.filter(dado => dado.nome.includes(dadoParaInserir.nome)).length > 0){
            return;
        }
        arrayDados = dadosSalvos;
    }

    arrayDados.push(dadoParaInserir);
    localStorage.setItem(chaveLocalStorageBuscasRecentesLocalizacao, JSON.stringify(arrayDados));
}

export function eventoBuscarVagaRedirect(e) {
    e.preventDefault();
    const inputCargo = e.target.querySelector('input[name="cargo"]').value;
    const inputLocalizacao = e.target.querySelector('input[name="localizacao"]').value;
    
    vagasBuscasRecentesCargoAdicionar(inputCargo);
    vagasBuscasRecentesLocalizacaoAdicionar(inputLocalizacao);
    
    location.href = `/${CULTURE_EMPREGARE}/vagas?query=${inputCargo}&localidade=${inputLocalizacao}`;
}
